
/* 
    @type Presenter 
    @description 


    Background child component: Only usable in the background layer.  


    creates a idle -> main -> idle video loop that is activated on press.

    @example

     {
        "component": "Presenter",
        "props": {
            "style": "bottom:0; left: 25%;",
            "cssClass": "",
            "idle": "assets/video/steno_idle.webm",
            "main": "assets/video/steno_present.webm"
        }
    }

*/

Vue.component("Presenter", {

    props: ["config"],
    template: `
        <div class="Presenter">
            

            <video id="idle" :src="config.idle" autoplay playsinline muted loop></video>



            <li class="hotspot Stream hotspot--active"  @click="play">
                <div class="hotspot__outline_left"></div> 
                <div class="hotspot__title_wrapper"><h2>Se velkomst</h2></div> 
                <div class="hotspot__outline_right"></div> 
                <div class="hotspot-button" style="animation-name: loopPulse; animation-iteration-count: infinite; animation-duration: 15s; animation-delay: 1.5s;"></div>
            </li>

            <video id="main" :src="config.main" style="display:none;" playsinline></video>


            <li class="hotspot skip" @click="skip">
                <i>×</i>
            </li>


        </div>
    `,
    data () {
        return {
            isPlaying: false
        }
    },

    mounted () {

        this.videos = {
            idle: this.$el.querySelector("#idle"),
            main: this.$el.querySelector("#main")
        }

        this.videos.main.volume = 0.5;

        this.events = {

            "play": ()=> { 
                this.isPlaying = true;
                this.videos.idle.style.display = "none";
                this.videos.main.style.display = "block";
                this.$el.querySelector(".hotspot").style.opacity = 0;
                this.$el.querySelector(".hotspot.skip").style.opacity = 1;

            },
            "ended": ()=> {
                this.isPlaying = false;
                this.videos.idle.style.display = "block";
                this.videos.main.style.display = "none";
                this.$el.querySelector(".hotspot").style.opacity = 1;
                this.$el.querySelector(".hotspot.skip").style.opacity = 0;

                app.radio.$emit("hotspot-animation-cycle-enable");
                app.radio.$emit("chevron-ended");

                touchKit.TrackingManager.track(touchKit.TrackingManager.events.CONTENT_CLICKED, {
                    type: 'PresenterWatchedToEnd',
                    info: this.config.main
                });
             },

             "loadedmetadata": () => {
                 console.log("loadedmetadata", this.videos.idle.videoWidth)
                 this.$el.style.width = this.videos.idle.videoWidth + "px";
                 this.$el.style.height = this.videos.idle.videoHeight + "px";
             }
        };

        this.videos.idle.addEventListener("loadedmetadata", this.events.loadedmetadata)
        this.videos.main.addEventListener("play", this.events.play)
        this.videos.main.addEventListener("ended", this.events.ended)

        this.$el.querySelector(".hotspot.skip").style.opacity = 0;
    },

    destroy () {
        this.videos.idle.removeEventListener("loadedmetadata", this.events.loadedmetadata)
        this.videos.main.removeEventListener("play", this.events.play)
        this.videos.main.removeEventListener("ended", this.events.ended)
        this.videos.forEach(v => v.pause())
    },
    methods: {
        play () {
            if(!this.isPlaying) {
                this.videos.main.play();

                app.radio.$emit("hotspot-animation-cycle-disable");
                app.radio.$emit("chevron-playing");

                touchKit.TrackingManager.track(touchKit.TrackingManager.events.CONTENT_CLICKED, {
                    type: 'PresenterStarted',
                    info: this.config.main
                });
            }
        },
        skip () {
            this.videos.main.pause();
            this.isPlaying = false;
            this.videos.idle.style.display = "block";
            this.videos.main.style.display = "none";
            this.$el.querySelector(".hotspot.skip").style.opacity = 0;
            this.$el.querySelector(".hotspot").style.opacity = 1;

            app.radio.$emit("hotspot-animation-cycle-enable");
            app.radio.$emit("chevron-ended");

            touchKit.TrackingManager.track(touchKit.TrackingManager.events.CONTENT_CLICKED, {
                type: 'PresenterSkipped',
                info: this.config.main
            });
        }
    }
});